import React from "react";
import { ResetOrUpdatePasswordIA } from "./instantAnswersComponents/settings/ResetOrUpdatePasswordIA";
export var resetOrUpdatePassword = function resetOrUpdatePassword(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return RESET_OR_UPDATE_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return RESET_OR_UPDATE_DESCRIPTION();
    }
  };
};
var RESET_OR_UPDATE_TITLE = function RESET_OR_UPDATE_TITLE(strictLocalize) {
  return strictLocalize({
    id: "rZFZN9",
    defaultMessage: [{
      "type": 0,
      "value": "Repor ou atualizar a palavra-passe"
    }]
  });
};
var RESET_OR_UPDATE_DESCRIPTION = function RESET_OR_UPDATE_DESCRIPTION() {
  return /*#__PURE__*/React.createElement(ResetOrUpdatePasswordIA, null);
};